'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Utils$NimbusWeb = require("../utils/Utils.bs.js");
var Button$NimbusWeb = require("./Button.bs.js");
var Icon_LeftArrow$NimbusWeb = require("../icons/Icon_LeftArrow.bs.js");
var Icon_RightArrow$NimbusWeb = require("../icons/Icon_RightArrow.bs.js");

require("./SlideShow.css");

function getWidth(reactRef) {
  var rRef = reactRef.current;
  if (rRef !== undefined) {
    return Caml_option.valFromOption(rRef).clientWidth;
  } else {
    return 0;
  }
}

function SlideShow(Props) {
  var children = Props.children;
  var distanceOpt = Props.distance;
  var pageStartOpt = Props.pageStart;
  var distance = distanceOpt !== undefined ? distanceOpt : 200;
  var pageStart = pageStartOpt !== undefined ? pageStartOpt : 0;
  var match = React.useState(function () {
        return pageStart;
      });
  var setPage = match[1];
  var page = match[0];
  React.useEffect((function () {
          Curry._1(setPage, (function (param) {
                  return pageStart;
                }));
          
        }), [pageStart]);
  var match$1 = React.useState(function () {
        return window.innerWidth;
      });
  var setWindowWidth = match$1[1];
  var windowWidth = match$1[0];
  React.useEffect((function () {
          var handleWindowResize = function (param) {
            return Curry._1(setWindowWidth, (function (param) {
                          return window.innerWidth;
                        }));
          };
          window.addEventListener("resize", handleWindowResize);
          return (function (param) {
                    window.removeEventListener("resize", handleWindowResize);
                    
                  });
        }), []);
  var toPreviousPage = React.useCallback((function (param) {
          return Curry._1(setPage, (function (prev) {
                        return prev - 1 | 0;
                      }));
        }), []);
  var toNextPage = React.useCallback((function (param) {
          return Curry._1(setPage, (function (prev) {
                        return prev + 1 | 0;
                      }));
        }), []);
  var elementRef = React.useRef(undefined);
  var dummyRef = React.useRef(undefined);
  var distanceHalf = distance / 2 | 0;
  var itemWidth = Math.min(windowWidth, 400);
  var arrowLeftPos = windowWidth < 650 ? windowWidth / 2 | 0 : (itemWidth / 2 | 0) + distanceHalf | 0;
  var renderArrow = function (icon, onClick, offsetLeft, accessKey, ariaLabel) {
    var operator = offsetLeft < 0 ? "-" : "+";
    var left = "calc(50% " + (operator + (" " + (String(Math.abs(offsetLeft)) + "px)")));
    var arg = left;
    var styles = function (param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14, param$15, param$16, param$17, param$18, param$19, param$20, param$21, param$22, param$23, param$24, param$25, param$26, param$27, param$28, param$29, param$30, param$31, param$32, param$33, param$34, param$35, param$36, param$37, param$38, param$39, param$40, param$41, param$42, param$43, param$44, param$45, param$46, param$47, param$48, param$49, param$50, param$51, param$52, param$53, param$54, param$55, param$56, param$57, param$58, param$59, param$60, param$61, param$62, param$63, param$64, param$65, param$66, param$67, param$68, param$69, param$70, param$71, param$72, param$73, param$74, param$75, param$76, param$77, param$78, param$79, param$80, param$81, param$82, param$83, param$84, param$85, param$86, param$87, param$88, param$89, param$90, param$91, param$92, param$93, param$94, param$95, param$96, param$97, param$98, param$99, param$100, param$101, param$102, param$103, param$104, param$105, param$106, param$107, param$108, param$109, param$110, param$111, param$112, param$113, param$114, param$115, param$116, param$117, param$118, param$119, param$120, param$121, param$122, param$123, param$124, param$125, param$126, param$127, param$128, param$129, param$130, param$131, param$132, param$133, param$134, param$135, param$136, param$137, param$138, param$139, param$140, param$141, param$142, param$143, param$144, param$145, param$146, param$147, param$148, param$149, param$150, param$151, param$152, param$153, param$154, param$155, param$156, param$157, param$158, param$159, param$160, param$161, param$162, param$163, param$164, param$165, param$166, param$167, param$168, param$169, param$170, param$171, param$172, param$173, param$174, param$175, param$176, param$177, param$178, param$179, param$180, param$181, param$182, param$183, param$184, param$185, param$186, param$187, param$188, param$189, param$190, param$191, param$192, param$193, param$194, param$195, param$196, param$197, param$198, param$199, param$200, param$201, param$202, param$203, param$204, param$205, param$206, param$207, param$208, param$209, param$210, param$211, param$212, param$213, param$214, param$215, param$216, param$217, param$218, param$219, param$220, param$221, param$222, param$223, param$224, param$225, param$226, param$227, param$228, param$229, param$230, param$231, param$232, param$233, param$234, param$235, param$236, param$237, param$238, param$239, param$240, param$241, param$242, param$243, param$244, param$245, param$246, param$247, param$248, param$249, param$250, param$251, param$252, param$253, param$254, param$255, param$256, param$257, param$258, param$259, param$260, param$261, param$262, param$263, param$264, param$265, param$266, param$267, param$268, param$269, param$270, param$271, param$272, param$273, param$274, param$275, param$276, param$277, param$278, param$279, param$280, param$281) {
      var partial_arg = "translate(-50%, -50%)";
      var partial_arg$1 = "absolute";
      return function (param$282, param$283, param$284, param$285, param$286, param$287, param$288, param$289, param$290, param$291, param$292, param$293, param$294, param$295, param$296, param$297, param$298, param$299, param$300, param$301, param$302, param$303, param$304, param$305, param$306, param$307, param$308, param$309, param$310, param$311, param$312, param$313, param$314, param$315, param$316, param$317, param$318, param$319, param$320, param$321, param$322, param$323, param$324, param$325, param$326, param$327, param$328, param$329, param$330, param$331, param$332, param$333, param$334, param$335, param$336, param$337, param$338, param$339, param$340, param$341, param$342, param$343, param$344) {
        var tmp = {};
        if (param !== undefined) {
          tmp.azimuth = Caml_option.valFromOption(param);
        }
        if (param$1 !== undefined) {
          tmp.background = Caml_option.valFromOption(param$1);
        }
        if (param$2 !== undefined) {
          tmp.backgroundAttachment = Caml_option.valFromOption(param$2);
        }
        if (param$3 !== undefined) {
          tmp.backgroundColor = Caml_option.valFromOption(param$3);
        }
        if (param$4 !== undefined) {
          tmp.backgroundImage = Caml_option.valFromOption(param$4);
        }
        if (param$5 !== undefined) {
          tmp.backgroundPosition = Caml_option.valFromOption(param$5);
        }
        if (param$6 !== undefined) {
          tmp.backgroundRepeat = Caml_option.valFromOption(param$6);
        }
        if (param$7 !== undefined) {
          tmp.border = Caml_option.valFromOption(param$7);
        }
        if (param$8 !== undefined) {
          tmp.borderCollapse = Caml_option.valFromOption(param$8);
        }
        if (param$9 !== undefined) {
          tmp.borderColor = Caml_option.valFromOption(param$9);
        }
        if (param$10 !== undefined) {
          tmp.borderSpacing = Caml_option.valFromOption(param$10);
        }
        if (param$11 !== undefined) {
          tmp.borderStyle = Caml_option.valFromOption(param$11);
        }
        if (param$12 !== undefined) {
          tmp.borderTop = Caml_option.valFromOption(param$12);
        }
        if (param$13 !== undefined) {
          tmp.borderRight = Caml_option.valFromOption(param$13);
        }
        if (param$14 !== undefined) {
          tmp.borderBottom = Caml_option.valFromOption(param$14);
        }
        if (param$15 !== undefined) {
          tmp.borderLeft = Caml_option.valFromOption(param$15);
        }
        if (param$16 !== undefined) {
          tmp.borderTopColor = Caml_option.valFromOption(param$16);
        }
        if (param$17 !== undefined) {
          tmp.borderRightColor = Caml_option.valFromOption(param$17);
        }
        if (param$18 !== undefined) {
          tmp.borderBottomColor = Caml_option.valFromOption(param$18);
        }
        if (param$19 !== undefined) {
          tmp.borderLeftColor = Caml_option.valFromOption(param$19);
        }
        if (param$20 !== undefined) {
          tmp.borderTopStyle = Caml_option.valFromOption(param$20);
        }
        if (param$21 !== undefined) {
          tmp.borderRightStyle = Caml_option.valFromOption(param$21);
        }
        if (param$22 !== undefined) {
          tmp.borderBottomStyle = Caml_option.valFromOption(param$22);
        }
        if (param$23 !== undefined) {
          tmp.borderLeftStyle = Caml_option.valFromOption(param$23);
        }
        if (param$24 !== undefined) {
          tmp.borderTopWidth = Caml_option.valFromOption(param$24);
        }
        if (param$25 !== undefined) {
          tmp.borderRightWidth = Caml_option.valFromOption(param$25);
        }
        if (param$26 !== undefined) {
          tmp.borderBottomWidth = Caml_option.valFromOption(param$26);
        }
        if (param$27 !== undefined) {
          tmp.borderLeftWidth = Caml_option.valFromOption(param$27);
        }
        if (param$28 !== undefined) {
          tmp.borderWidth = Caml_option.valFromOption(param$28);
        }
        if (param$29 !== undefined) {
          tmp.bottom = Caml_option.valFromOption(param$29);
        }
        if (param$30 !== undefined) {
          tmp.captionSide = Caml_option.valFromOption(param$30);
        }
        if (param$31 !== undefined) {
          tmp.clear = Caml_option.valFromOption(param$31);
        }
        if (param$32 !== undefined) {
          tmp.clip = Caml_option.valFromOption(param$32);
        }
        if (param$33 !== undefined) {
          tmp.color = Caml_option.valFromOption(param$33);
        }
        if (param$34 !== undefined) {
          tmp.content = Caml_option.valFromOption(param$34);
        }
        if (param$35 !== undefined) {
          tmp.counterIncrement = Caml_option.valFromOption(param$35);
        }
        if (param$36 !== undefined) {
          tmp.counterReset = Caml_option.valFromOption(param$36);
        }
        if (param$37 !== undefined) {
          tmp.cue = Caml_option.valFromOption(param$37);
        }
        if (param$38 !== undefined) {
          tmp.cueAfter = Caml_option.valFromOption(param$38);
        }
        if (param$39 !== undefined) {
          tmp.cueBefore = Caml_option.valFromOption(param$39);
        }
        if (param$40 !== undefined) {
          tmp.cursor = Caml_option.valFromOption(param$40);
        }
        if (param$41 !== undefined) {
          tmp.direction = Caml_option.valFromOption(param$41);
        }
        if (param$42 !== undefined) {
          tmp.display = Caml_option.valFromOption(param$42);
        }
        if (param$43 !== undefined) {
          tmp.elevation = Caml_option.valFromOption(param$43);
        }
        if (param$44 !== undefined) {
          tmp.emptyCells = Caml_option.valFromOption(param$44);
        }
        if (param$45 !== undefined) {
          tmp.float = Caml_option.valFromOption(param$45);
        }
        if (param$46 !== undefined) {
          tmp.font = Caml_option.valFromOption(param$46);
        }
        if (param$47 !== undefined) {
          tmp.fontFamily = Caml_option.valFromOption(param$47);
        }
        if (param$48 !== undefined) {
          tmp.fontSize = Caml_option.valFromOption(param$48);
        }
        if (param$49 !== undefined) {
          tmp.fontSizeAdjust = Caml_option.valFromOption(param$49);
        }
        if (param$50 !== undefined) {
          tmp.fontStretch = Caml_option.valFromOption(param$50);
        }
        if (param$51 !== undefined) {
          tmp.fontStyle = Caml_option.valFromOption(param$51);
        }
        if (param$52 !== undefined) {
          tmp.fontVariant = Caml_option.valFromOption(param$52);
        }
        if (param$53 !== undefined) {
          tmp.fontWeight = Caml_option.valFromOption(param$53);
        }
        if (param$54 !== undefined) {
          tmp.height = Caml_option.valFromOption(param$54);
        }
        if (arg !== undefined) {
          tmp.left = Caml_option.valFromOption(arg);
        }
        if (param$55 !== undefined) {
          tmp.letterSpacing = Caml_option.valFromOption(param$55);
        }
        if (param$56 !== undefined) {
          tmp.lineHeight = Caml_option.valFromOption(param$56);
        }
        if (param$57 !== undefined) {
          tmp.listStyle = Caml_option.valFromOption(param$57);
        }
        if (param$58 !== undefined) {
          tmp.listStyleImage = Caml_option.valFromOption(param$58);
        }
        if (param$59 !== undefined) {
          tmp.listStylePosition = Caml_option.valFromOption(param$59);
        }
        if (param$60 !== undefined) {
          tmp.listStyleType = Caml_option.valFromOption(param$60);
        }
        if (param$61 !== undefined) {
          tmp.margin = Caml_option.valFromOption(param$61);
        }
        if (param$62 !== undefined) {
          tmp.marginTop = Caml_option.valFromOption(param$62);
        }
        if (param$63 !== undefined) {
          tmp.marginRight = Caml_option.valFromOption(param$63);
        }
        if (param$64 !== undefined) {
          tmp.marginBottom = Caml_option.valFromOption(param$64);
        }
        if (param$65 !== undefined) {
          tmp.marginLeft = Caml_option.valFromOption(param$65);
        }
        if (param$66 !== undefined) {
          tmp.markerOffset = Caml_option.valFromOption(param$66);
        }
        if (param$67 !== undefined) {
          tmp.marks = Caml_option.valFromOption(param$67);
        }
        if (param$68 !== undefined) {
          tmp.maxHeight = Caml_option.valFromOption(param$68);
        }
        if (param$69 !== undefined) {
          tmp.maxWidth = Caml_option.valFromOption(param$69);
        }
        if (param$70 !== undefined) {
          tmp.minHeight = Caml_option.valFromOption(param$70);
        }
        if (param$71 !== undefined) {
          tmp.minWidth = Caml_option.valFromOption(param$71);
        }
        if (param$72 !== undefined) {
          tmp.orphans = Caml_option.valFromOption(param$72);
        }
        if (param$73 !== undefined) {
          tmp.outline = Caml_option.valFromOption(param$73);
        }
        if (param$74 !== undefined) {
          tmp.outlineColor = Caml_option.valFromOption(param$74);
        }
        if (param$75 !== undefined) {
          tmp.outlineStyle = Caml_option.valFromOption(param$75);
        }
        if (param$76 !== undefined) {
          tmp.outlineWidth = Caml_option.valFromOption(param$76);
        }
        if (param$77 !== undefined) {
          tmp.overflow = Caml_option.valFromOption(param$77);
        }
        if (param$78 !== undefined) {
          tmp.overflowX = Caml_option.valFromOption(param$78);
        }
        if (param$79 !== undefined) {
          tmp.overflowY = Caml_option.valFromOption(param$79);
        }
        if (param$80 !== undefined) {
          tmp.padding = Caml_option.valFromOption(param$80);
        }
        if (param$81 !== undefined) {
          tmp.paddingTop = Caml_option.valFromOption(param$81);
        }
        if (param$82 !== undefined) {
          tmp.paddingRight = Caml_option.valFromOption(param$82);
        }
        if (param$83 !== undefined) {
          tmp.paddingBottom = Caml_option.valFromOption(param$83);
        }
        if (param$84 !== undefined) {
          tmp.paddingLeft = Caml_option.valFromOption(param$84);
        }
        if (param$85 !== undefined) {
          tmp.page = Caml_option.valFromOption(param$85);
        }
        if (param$86 !== undefined) {
          tmp.pageBreakAfter = Caml_option.valFromOption(param$86);
        }
        if (param$87 !== undefined) {
          tmp.pageBreakBefore = Caml_option.valFromOption(param$87);
        }
        if (param$88 !== undefined) {
          tmp.pageBreakInside = Caml_option.valFromOption(param$88);
        }
        if (param$89 !== undefined) {
          tmp.pause = Caml_option.valFromOption(param$89);
        }
        if (param$90 !== undefined) {
          tmp.pauseAfter = Caml_option.valFromOption(param$90);
        }
        if (param$91 !== undefined) {
          tmp.pauseBefore = Caml_option.valFromOption(param$91);
        }
        if (param$92 !== undefined) {
          tmp.pitch = Caml_option.valFromOption(param$92);
        }
        if (param$93 !== undefined) {
          tmp.pitchRange = Caml_option.valFromOption(param$93);
        }
        if (param$94 !== undefined) {
          tmp.playDuring = Caml_option.valFromOption(param$94);
        }
        if (partial_arg$1 !== undefined) {
          tmp.position = Caml_option.valFromOption(partial_arg$1);
        }
        if (param$95 !== undefined) {
          tmp.quotes = Caml_option.valFromOption(param$95);
        }
        if (param$96 !== undefined) {
          tmp.richness = Caml_option.valFromOption(param$96);
        }
        if (param$97 !== undefined) {
          tmp.right = Caml_option.valFromOption(param$97);
        }
        if (param$98 !== undefined) {
          tmp.size = Caml_option.valFromOption(param$98);
        }
        if (param$99 !== undefined) {
          tmp.speak = Caml_option.valFromOption(param$99);
        }
        if (param$100 !== undefined) {
          tmp.speakHeader = Caml_option.valFromOption(param$100);
        }
        if (param$101 !== undefined) {
          tmp.speakNumeral = Caml_option.valFromOption(param$101);
        }
        if (param$102 !== undefined) {
          tmp.speakPunctuation = Caml_option.valFromOption(param$102);
        }
        if (param$103 !== undefined) {
          tmp.speechRate = Caml_option.valFromOption(param$103);
        }
        if (param$104 !== undefined) {
          tmp.stress = Caml_option.valFromOption(param$104);
        }
        if (param$105 !== undefined) {
          tmp.tableLayout = Caml_option.valFromOption(param$105);
        }
        if (param$106 !== undefined) {
          tmp.textAlign = Caml_option.valFromOption(param$106);
        }
        if (param$107 !== undefined) {
          tmp.textDecoration = Caml_option.valFromOption(param$107);
        }
        if (param$108 !== undefined) {
          tmp.textIndent = Caml_option.valFromOption(param$108);
        }
        if (param$109 !== undefined) {
          tmp.textShadow = Caml_option.valFromOption(param$109);
        }
        if (param$110 !== undefined) {
          tmp.textTransform = Caml_option.valFromOption(param$110);
        }
        if (param$111 !== undefined) {
          tmp.top = Caml_option.valFromOption(param$111);
        }
        if (param$112 !== undefined) {
          tmp.unicodeBidi = Caml_option.valFromOption(param$112);
        }
        if (param$113 !== undefined) {
          tmp.verticalAlign = Caml_option.valFromOption(param$113);
        }
        if (param$114 !== undefined) {
          tmp.visibility = Caml_option.valFromOption(param$114);
        }
        if (param$115 !== undefined) {
          tmp.voiceFamily = Caml_option.valFromOption(param$115);
        }
        if (param$116 !== undefined) {
          tmp.volume = Caml_option.valFromOption(param$116);
        }
        if (param$117 !== undefined) {
          tmp.whiteSpace = Caml_option.valFromOption(param$117);
        }
        if (param$118 !== undefined) {
          tmp.widows = Caml_option.valFromOption(param$118);
        }
        if (param$119 !== undefined) {
          tmp.width = Caml_option.valFromOption(param$119);
        }
        if (param$120 !== undefined) {
          tmp.wordSpacing = Caml_option.valFromOption(param$120);
        }
        if (param$121 !== undefined) {
          tmp.zIndex = Caml_option.valFromOption(param$121);
        }
        if (param$122 !== undefined) {
          tmp.opacity = Caml_option.valFromOption(param$122);
        }
        if (param$123 !== undefined) {
          tmp.backgroundOrigin = Caml_option.valFromOption(param$123);
        }
        if (param$124 !== undefined) {
          tmp.backgroundSize = Caml_option.valFromOption(param$124);
        }
        if (param$125 !== undefined) {
          tmp.backgroundClip = Caml_option.valFromOption(param$125);
        }
        if (param$126 !== undefined) {
          tmp.borderRadius = Caml_option.valFromOption(param$126);
        }
        if (param$127 !== undefined) {
          tmp.borderTopLeftRadius = Caml_option.valFromOption(param$127);
        }
        if (param$128 !== undefined) {
          tmp.borderTopRightRadius = Caml_option.valFromOption(param$128);
        }
        if (param$129 !== undefined) {
          tmp.borderBottomLeftRadius = Caml_option.valFromOption(param$129);
        }
        if (param$130 !== undefined) {
          tmp.borderBottomRightRadius = Caml_option.valFromOption(param$130);
        }
        if (param$131 !== undefined) {
          tmp.borderImage = Caml_option.valFromOption(param$131);
        }
        if (param$132 !== undefined) {
          tmp.borderImageSource = Caml_option.valFromOption(param$132);
        }
        if (param$133 !== undefined) {
          tmp.borderImageSlice = Caml_option.valFromOption(param$133);
        }
        if (param$134 !== undefined) {
          tmp.borderImageWidth = Caml_option.valFromOption(param$134);
        }
        if (param$135 !== undefined) {
          tmp.borderImageOutset = Caml_option.valFromOption(param$135);
        }
        if (param$136 !== undefined) {
          tmp.borderImageRepeat = Caml_option.valFromOption(param$136);
        }
        if (param$137 !== undefined) {
          tmp.boxShadow = Caml_option.valFromOption(param$137);
        }
        if (param$138 !== undefined) {
          tmp.columns = Caml_option.valFromOption(param$138);
        }
        if (param$139 !== undefined) {
          tmp.columnCount = Caml_option.valFromOption(param$139);
        }
        if (param$140 !== undefined) {
          tmp.columnFill = Caml_option.valFromOption(param$140);
        }
        if (param$141 !== undefined) {
          tmp.columnGap = Caml_option.valFromOption(param$141);
        }
        if (param$142 !== undefined) {
          tmp.columnRule = Caml_option.valFromOption(param$142);
        }
        if (param$143 !== undefined) {
          tmp.columnRuleColor = Caml_option.valFromOption(param$143);
        }
        if (param$144 !== undefined) {
          tmp.columnRuleStyle = Caml_option.valFromOption(param$144);
        }
        if (param$145 !== undefined) {
          tmp.columnRuleWidth = Caml_option.valFromOption(param$145);
        }
        if (param$146 !== undefined) {
          tmp.columnSpan = Caml_option.valFromOption(param$146);
        }
        if (param$147 !== undefined) {
          tmp.columnWidth = Caml_option.valFromOption(param$147);
        }
        if (param$148 !== undefined) {
          tmp.breakAfter = Caml_option.valFromOption(param$148);
        }
        if (param$149 !== undefined) {
          tmp.breakBefore = Caml_option.valFromOption(param$149);
        }
        if (param$150 !== undefined) {
          tmp.breakInside = Caml_option.valFromOption(param$150);
        }
        if (param$151 !== undefined) {
          tmp.rest = Caml_option.valFromOption(param$151);
        }
        if (param$152 !== undefined) {
          tmp.restAfter = Caml_option.valFromOption(param$152);
        }
        if (param$153 !== undefined) {
          tmp.restBefore = Caml_option.valFromOption(param$153);
        }
        if (param$154 !== undefined) {
          tmp.speakAs = Caml_option.valFromOption(param$154);
        }
        if (param$155 !== undefined) {
          tmp.voiceBalance = Caml_option.valFromOption(param$155);
        }
        if (param$156 !== undefined) {
          tmp.voiceDuration = Caml_option.valFromOption(param$156);
        }
        if (param$157 !== undefined) {
          tmp.voicePitch = Caml_option.valFromOption(param$157);
        }
        if (param$158 !== undefined) {
          tmp.voiceRange = Caml_option.valFromOption(param$158);
        }
        if (param$159 !== undefined) {
          tmp.voiceRate = Caml_option.valFromOption(param$159);
        }
        if (param$160 !== undefined) {
          tmp.voiceStress = Caml_option.valFromOption(param$160);
        }
        if (param$161 !== undefined) {
          tmp.voiceVolume = Caml_option.valFromOption(param$161);
        }
        if (param$162 !== undefined) {
          tmp.objectFit = Caml_option.valFromOption(param$162);
        }
        if (param$163 !== undefined) {
          tmp.objectPosition = Caml_option.valFromOption(param$163);
        }
        if (param$164 !== undefined) {
          tmp.imageResolution = Caml_option.valFromOption(param$164);
        }
        if (param$165 !== undefined) {
          tmp.imageOrientation = Caml_option.valFromOption(param$165);
        }
        if (param$166 !== undefined) {
          tmp.alignContent = Caml_option.valFromOption(param$166);
        }
        if (param$167 !== undefined) {
          tmp.alignItems = Caml_option.valFromOption(param$167);
        }
        if (param$168 !== undefined) {
          tmp.alignSelf = Caml_option.valFromOption(param$168);
        }
        if (param$169 !== undefined) {
          tmp.flex = Caml_option.valFromOption(param$169);
        }
        if (param$170 !== undefined) {
          tmp.flexBasis = Caml_option.valFromOption(param$170);
        }
        if (param$171 !== undefined) {
          tmp.flexDirection = Caml_option.valFromOption(param$171);
        }
        if (param$172 !== undefined) {
          tmp.flexFlow = Caml_option.valFromOption(param$172);
        }
        if (param$173 !== undefined) {
          tmp.flexGrow = Caml_option.valFromOption(param$173);
        }
        if (param$174 !== undefined) {
          tmp.flexShrink = Caml_option.valFromOption(param$174);
        }
        if (param$175 !== undefined) {
          tmp.flexWrap = Caml_option.valFromOption(param$175);
        }
        if (param$176 !== undefined) {
          tmp.justifyContent = Caml_option.valFromOption(param$176);
        }
        if (param$177 !== undefined) {
          tmp.order = Caml_option.valFromOption(param$177);
        }
        if (param$178 !== undefined) {
          tmp.textDecorationColor = Caml_option.valFromOption(param$178);
        }
        if (param$179 !== undefined) {
          tmp.textDecorationLine = Caml_option.valFromOption(param$179);
        }
        if (param$180 !== undefined) {
          tmp.textDecorationSkip = Caml_option.valFromOption(param$180);
        }
        if (param$181 !== undefined) {
          tmp.textDecorationStyle = Caml_option.valFromOption(param$181);
        }
        if (param$182 !== undefined) {
          tmp.textEmphasis = Caml_option.valFromOption(param$182);
        }
        if (param$183 !== undefined) {
          tmp.textEmphasisColor = Caml_option.valFromOption(param$183);
        }
        if (param$184 !== undefined) {
          tmp.textEmphasisPosition = Caml_option.valFromOption(param$184);
        }
        if (param$185 !== undefined) {
          tmp.textEmphasisStyle = Caml_option.valFromOption(param$185);
        }
        if (param$186 !== undefined) {
          tmp.textUnderlinePosition = Caml_option.valFromOption(param$186);
        }
        if (param$187 !== undefined) {
          tmp.fontFeatureSettings = Caml_option.valFromOption(param$187);
        }
        if (param$188 !== undefined) {
          tmp.fontKerning = Caml_option.valFromOption(param$188);
        }
        if (param$189 !== undefined) {
          tmp.fontLanguageOverride = Caml_option.valFromOption(param$189);
        }
        if (param$190 !== undefined) {
          tmp.fontSynthesis = Caml_option.valFromOption(param$190);
        }
        if (param$191 !== undefined) {
          tmp.forntVariantAlternates = Caml_option.valFromOption(param$191);
        }
        if (param$192 !== undefined) {
          tmp.fontVariantCaps = Caml_option.valFromOption(param$192);
        }
        if (param$193 !== undefined) {
          tmp.fontVariantEastAsian = Caml_option.valFromOption(param$193);
        }
        if (param$194 !== undefined) {
          tmp.fontVariantLigatures = Caml_option.valFromOption(param$194);
        }
        if (param$195 !== undefined) {
          tmp.fontVariantNumeric = Caml_option.valFromOption(param$195);
        }
        if (param$196 !== undefined) {
          tmp.fontVariantPosition = Caml_option.valFromOption(param$196);
        }
        if (param$197 !== undefined) {
          tmp.all = Caml_option.valFromOption(param$197);
        }
        if (param$198 !== undefined) {
          tmp.glyphOrientationVertical = Caml_option.valFromOption(param$198);
        }
        if (param$199 !== undefined) {
          tmp.textCombineUpright = Caml_option.valFromOption(param$199);
        }
        if (param$200 !== undefined) {
          tmp.textOrientation = Caml_option.valFromOption(param$200);
        }
        if (param$201 !== undefined) {
          tmp.writingMode = Caml_option.valFromOption(param$201);
        }
        if (param$202 !== undefined) {
          tmp.shapeImageThreshold = Caml_option.valFromOption(param$202);
        }
        if (param$203 !== undefined) {
          tmp.shapeMargin = Caml_option.valFromOption(param$203);
        }
        if (param$204 !== undefined) {
          tmp.shapeOutside = Caml_option.valFromOption(param$204);
        }
        if (param$205 !== undefined) {
          tmp.clipPath = Caml_option.valFromOption(param$205);
        }
        if (param$206 !== undefined) {
          tmp.clipRule = Caml_option.valFromOption(param$206);
        }
        if (param$207 !== undefined) {
          tmp.mask = Caml_option.valFromOption(param$207);
        }
        if (param$208 !== undefined) {
          tmp.maskBorder = Caml_option.valFromOption(param$208);
        }
        if (param$209 !== undefined) {
          tmp.maskBorderMode = Caml_option.valFromOption(param$209);
        }
        if (param$210 !== undefined) {
          tmp.maskBorderOutset = Caml_option.valFromOption(param$210);
        }
        if (param$211 !== undefined) {
          tmp.maskBorderRepeat = Caml_option.valFromOption(param$211);
        }
        if (param$212 !== undefined) {
          tmp.maskBorderSlice = Caml_option.valFromOption(param$212);
        }
        if (param$213 !== undefined) {
          tmp.maskBorderSource = Caml_option.valFromOption(param$213);
        }
        if (param$214 !== undefined) {
          tmp.maskBorderWidth = Caml_option.valFromOption(param$214);
        }
        if (param$215 !== undefined) {
          tmp.maskClip = Caml_option.valFromOption(param$215);
        }
        if (param$216 !== undefined) {
          tmp.maskComposite = Caml_option.valFromOption(param$216);
        }
        if (param$217 !== undefined) {
          tmp.maskImage = Caml_option.valFromOption(param$217);
        }
        if (param$218 !== undefined) {
          tmp.maskMode = Caml_option.valFromOption(param$218);
        }
        if (param$219 !== undefined) {
          tmp.maskOrigin = Caml_option.valFromOption(param$219);
        }
        if (param$220 !== undefined) {
          tmp.maskPosition = Caml_option.valFromOption(param$220);
        }
        if (param$221 !== undefined) {
          tmp.maskRepeat = Caml_option.valFromOption(param$221);
        }
        if (param$222 !== undefined) {
          tmp.maskSize = Caml_option.valFromOption(param$222);
        }
        if (param$223 !== undefined) {
          tmp.maskType = Caml_option.valFromOption(param$223);
        }
        if (param$224 !== undefined) {
          tmp.backgroundBlendMode = Caml_option.valFromOption(param$224);
        }
        if (param$225 !== undefined) {
          tmp.isolation = Caml_option.valFromOption(param$225);
        }
        if (param$226 !== undefined) {
          tmp.mixBlendMode = Caml_option.valFromOption(param$226);
        }
        if (param$227 !== undefined) {
          tmp.boxDecorationBreak = Caml_option.valFromOption(param$227);
        }
        if (param$228 !== undefined) {
          tmp.boxSizing = Caml_option.valFromOption(param$228);
        }
        if (param$229 !== undefined) {
          tmp.caretColor = Caml_option.valFromOption(param$229);
        }
        if (param$230 !== undefined) {
          tmp.navDown = Caml_option.valFromOption(param$230);
        }
        if (param$231 !== undefined) {
          tmp.navLeft = Caml_option.valFromOption(param$231);
        }
        if (param$232 !== undefined) {
          tmp.navRight = Caml_option.valFromOption(param$232);
        }
        if (param$233 !== undefined) {
          tmp.navUp = Caml_option.valFromOption(param$233);
        }
        if (param$234 !== undefined) {
          tmp.outlineOffset = Caml_option.valFromOption(param$234);
        }
        if (param$235 !== undefined) {
          tmp.resize = Caml_option.valFromOption(param$235);
        }
        if (param$236 !== undefined) {
          tmp.textOverflow = Caml_option.valFromOption(param$236);
        }
        if (param$237 !== undefined) {
          tmp.grid = Caml_option.valFromOption(param$237);
        }
        if (param$238 !== undefined) {
          tmp.gridArea = Caml_option.valFromOption(param$238);
        }
        if (param$239 !== undefined) {
          tmp.gridAutoColumns = Caml_option.valFromOption(param$239);
        }
        if (param$240 !== undefined) {
          tmp.gridAutoFlow = Caml_option.valFromOption(param$240);
        }
        if (param$241 !== undefined) {
          tmp.gridAutoRows = Caml_option.valFromOption(param$241);
        }
        if (param$242 !== undefined) {
          tmp.gridColumn = Caml_option.valFromOption(param$242);
        }
        if (param$243 !== undefined) {
          tmp.gridColumnEnd = Caml_option.valFromOption(param$243);
        }
        if (param$244 !== undefined) {
          tmp.gridColumnGap = Caml_option.valFromOption(param$244);
        }
        if (param$245 !== undefined) {
          tmp.gridColumnStart = Caml_option.valFromOption(param$245);
        }
        if (param$246 !== undefined) {
          tmp.gridGap = Caml_option.valFromOption(param$246);
        }
        if (param$247 !== undefined) {
          tmp.gridRow = Caml_option.valFromOption(param$247);
        }
        if (param$248 !== undefined) {
          tmp.gridRowEnd = Caml_option.valFromOption(param$248);
        }
        if (param$249 !== undefined) {
          tmp.gridRowGap = Caml_option.valFromOption(param$249);
        }
        if (param$250 !== undefined) {
          tmp.gridRowStart = Caml_option.valFromOption(param$250);
        }
        if (param$251 !== undefined) {
          tmp.gridTemplate = Caml_option.valFromOption(param$251);
        }
        if (param$252 !== undefined) {
          tmp.gridTemplateAreas = Caml_option.valFromOption(param$252);
        }
        if (param$253 !== undefined) {
          tmp.gridTemplateColumns = Caml_option.valFromOption(param$253);
        }
        if (param$254 !== undefined) {
          tmp.gridTemplateRows = Caml_option.valFromOption(param$254);
        }
        if (param$255 !== undefined) {
          tmp.willChange = Caml_option.valFromOption(param$255);
        }
        if (param$256 !== undefined) {
          tmp.hangingPunctuation = Caml_option.valFromOption(param$256);
        }
        if (param$257 !== undefined) {
          tmp.hyphens = Caml_option.valFromOption(param$257);
        }
        if (param$258 !== undefined) {
          tmp.lineBreak = Caml_option.valFromOption(param$258);
        }
        if (param$259 !== undefined) {
          tmp.overflowWrap = Caml_option.valFromOption(param$259);
        }
        if (param$260 !== undefined) {
          tmp.tabSize = Caml_option.valFromOption(param$260);
        }
        if (param$261 !== undefined) {
          tmp.textAlignLast = Caml_option.valFromOption(param$261);
        }
        if (param$262 !== undefined) {
          tmp.textJustify = Caml_option.valFromOption(param$262);
        }
        if (param$263 !== undefined) {
          tmp.wordBreak = Caml_option.valFromOption(param$263);
        }
        if (param$264 !== undefined) {
          tmp.wordWrap = Caml_option.valFromOption(param$264);
        }
        if (param$265 !== undefined) {
          tmp.animation = Caml_option.valFromOption(param$265);
        }
        if (param$266 !== undefined) {
          tmp.animationDelay = Caml_option.valFromOption(param$266);
        }
        if (param$267 !== undefined) {
          tmp.animationDirection = Caml_option.valFromOption(param$267);
        }
        if (param$268 !== undefined) {
          tmp.animationDuration = Caml_option.valFromOption(param$268);
        }
        if (param$269 !== undefined) {
          tmp.animationFillMode = Caml_option.valFromOption(param$269);
        }
        if (param$270 !== undefined) {
          tmp.animationIterationCount = Caml_option.valFromOption(param$270);
        }
        if (param$271 !== undefined) {
          tmp.animationName = Caml_option.valFromOption(param$271);
        }
        if (param$272 !== undefined) {
          tmp.animationPlayState = Caml_option.valFromOption(param$272);
        }
        if (param$273 !== undefined) {
          tmp.animationTimingFunction = Caml_option.valFromOption(param$273);
        }
        if (param$274 !== undefined) {
          tmp.transition = Caml_option.valFromOption(param$274);
        }
        if (param$275 !== undefined) {
          tmp.transitionDelay = Caml_option.valFromOption(param$275);
        }
        if (param$276 !== undefined) {
          tmp.transitionDuration = Caml_option.valFromOption(param$276);
        }
        if (param$277 !== undefined) {
          tmp.transitionProperty = Caml_option.valFromOption(param$277);
        }
        if (param$278 !== undefined) {
          tmp.transitionTimingFunction = Caml_option.valFromOption(param$278);
        }
        if (param$279 !== undefined) {
          tmp.backfaceVisibility = Caml_option.valFromOption(param$279);
        }
        if (param$280 !== undefined) {
          tmp.perspective = Caml_option.valFromOption(param$280);
        }
        if (param$281 !== undefined) {
          tmp.perspectiveOrigin = Caml_option.valFromOption(param$281);
        }
        if (partial_arg !== undefined) {
          tmp.transform = Caml_option.valFromOption(partial_arg);
        }
        if (param$282 !== undefined) {
          tmp.transformOrigin = Caml_option.valFromOption(param$282);
        }
        if (param$283 !== undefined) {
          tmp.transformStyle = Caml_option.valFromOption(param$283);
        }
        if (param$284 !== undefined) {
          tmp.justifyItems = Caml_option.valFromOption(param$284);
        }
        if (param$285 !== undefined) {
          tmp.justifySelf = Caml_option.valFromOption(param$285);
        }
        if (param$286 !== undefined) {
          tmp.placeContent = Caml_option.valFromOption(param$286);
        }
        if (param$287 !== undefined) {
          tmp.placeItems = Caml_option.valFromOption(param$287);
        }
        if (param$288 !== undefined) {
          tmp.placeSelf = Caml_option.valFromOption(param$288);
        }
        if (param$289 !== undefined) {
          tmp.appearance = Caml_option.valFromOption(param$289);
        }
        if (param$290 !== undefined) {
          tmp.caret = Caml_option.valFromOption(param$290);
        }
        if (param$291 !== undefined) {
          tmp.caretAnimation = Caml_option.valFromOption(param$291);
        }
        if (param$292 !== undefined) {
          tmp.caretShape = Caml_option.valFromOption(param$292);
        }
        if (param$293 !== undefined) {
          tmp.userSelect = Caml_option.valFromOption(param$293);
        }
        if (param$294 !== undefined) {
          tmp.maxLines = Caml_option.valFromOption(param$294);
        }
        if (param$295 !== undefined) {
          tmp.marqueeDirection = Caml_option.valFromOption(param$295);
        }
        if (param$296 !== undefined) {
          tmp.marqueeLoop = Caml_option.valFromOption(param$296);
        }
        if (param$297 !== undefined) {
          tmp.marqueeSpeed = Caml_option.valFromOption(param$297);
        }
        if (param$298 !== undefined) {
          tmp.marqueeStyle = Caml_option.valFromOption(param$298);
        }
        if (param$299 !== undefined) {
          tmp.overflowStyle = Caml_option.valFromOption(param$299);
        }
        if (param$300 !== undefined) {
          tmp.rotation = Caml_option.valFromOption(param$300);
        }
        if (param$301 !== undefined) {
          tmp.rotationPoint = Caml_option.valFromOption(param$301);
        }
        if (param$302 !== undefined) {
          tmp.alignmentBaseline = Caml_option.valFromOption(param$302);
        }
        if (param$303 !== undefined) {
          tmp.baselineShift = Caml_option.valFromOption(param$303);
        }
        if (param$304 !== undefined) {
          tmp.clip = Caml_option.valFromOption(param$304);
        }
        if (param$305 !== undefined) {
          tmp.clipPath = Caml_option.valFromOption(param$305);
        }
        if (param$306 !== undefined) {
          tmp.clipRule = Caml_option.valFromOption(param$306);
        }
        if (param$307 !== undefined) {
          tmp.colorInterpolation = Caml_option.valFromOption(param$307);
        }
        if (param$308 !== undefined) {
          tmp.colorInterpolationFilters = Caml_option.valFromOption(param$308);
        }
        if (param$309 !== undefined) {
          tmp.colorProfile = Caml_option.valFromOption(param$309);
        }
        if (param$310 !== undefined) {
          tmp.colorRendering = Caml_option.valFromOption(param$310);
        }
        if (param$311 !== undefined) {
          tmp.cursor = Caml_option.valFromOption(param$311);
        }
        if (param$312 !== undefined) {
          tmp.dominantBaseline = Caml_option.valFromOption(param$312);
        }
        if (param$313 !== undefined) {
          tmp.fill = Caml_option.valFromOption(param$313);
        }
        if (param$314 !== undefined) {
          tmp.fillOpacity = Caml_option.valFromOption(param$314);
        }
        if (param$315 !== undefined) {
          tmp.fillRule = Caml_option.valFromOption(param$315);
        }
        if (param$316 !== undefined) {
          tmp.filter = Caml_option.valFromOption(param$316);
        }
        if (param$317 !== undefined) {
          tmp.floodColor = Caml_option.valFromOption(param$317);
        }
        if (param$318 !== undefined) {
          tmp.floodOpacity = Caml_option.valFromOption(param$318);
        }
        if (param$319 !== undefined) {
          tmp.glyphOrientationHorizontal = Caml_option.valFromOption(param$319);
        }
        if (param$320 !== undefined) {
          tmp.glyphOrientationVertical = Caml_option.valFromOption(param$320);
        }
        if (param$321 !== undefined) {
          tmp.imageRendering = Caml_option.valFromOption(param$321);
        }
        if (param$322 !== undefined) {
          tmp.kerning = Caml_option.valFromOption(param$322);
        }
        if (param$323 !== undefined) {
          tmp.lightingColor = Caml_option.valFromOption(param$323);
        }
        if (param$324 !== undefined) {
          tmp.markerEnd = Caml_option.valFromOption(param$324);
        }
        if (param$325 !== undefined) {
          tmp.markerMid = Caml_option.valFromOption(param$325);
        }
        if (param$326 !== undefined) {
          tmp.markerStart = Caml_option.valFromOption(param$326);
        }
        if (param$327 !== undefined) {
          tmp.pointerEvents = Caml_option.valFromOption(param$327);
        }
        if (param$328 !== undefined) {
          tmp.shapeRendering = Caml_option.valFromOption(param$328);
        }
        if (param$329 !== undefined) {
          tmp.stopColor = Caml_option.valFromOption(param$329);
        }
        if (param$330 !== undefined) {
          tmp.stopOpacity = Caml_option.valFromOption(param$330);
        }
        if (param$331 !== undefined) {
          tmp.stroke = Caml_option.valFromOption(param$331);
        }
        if (param$332 !== undefined) {
          tmp.strokeDasharray = Caml_option.valFromOption(param$332);
        }
        if (param$333 !== undefined) {
          tmp.strokeDashoffset = Caml_option.valFromOption(param$333);
        }
        if (param$334 !== undefined) {
          tmp.strokeLinecap = Caml_option.valFromOption(param$334);
        }
        if (param$335 !== undefined) {
          tmp.strokeLinejoin = Caml_option.valFromOption(param$335);
        }
        if (param$336 !== undefined) {
          tmp.strokeMiterlimit = Caml_option.valFromOption(param$336);
        }
        if (param$337 !== undefined) {
          tmp.strokeOpacity = Caml_option.valFromOption(param$337);
        }
        if (param$338 !== undefined) {
          tmp.strokeWidth = Caml_option.valFromOption(param$338);
        }
        if (param$339 !== undefined) {
          tmp.textAnchor = Caml_option.valFromOption(param$339);
        }
        if (param$340 !== undefined) {
          tmp.textRendering = Caml_option.valFromOption(param$340);
        }
        if (param$341 !== undefined) {
          tmp.rubyAlign = Caml_option.valFromOption(param$341);
        }
        if (param$342 !== undefined) {
          tmp.rubyMerge = Caml_option.valFromOption(param$342);
        }
        if (param$343 !== undefined) {
          tmp.rubyPosition = Caml_option.valFromOption(param$343);
        }
        return tmp;
      };
    };
    return React.createElement("div", {
                style: windowWidth < 650 ? styles(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "45px", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined) : styles(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "50%", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
              }, React.createElement(Button$NimbusWeb.Icon.make, {
                    className: "slide-show-arrow-button",
                    onClick: onClick,
                    bgColor: /* White */10,
                    children: icon,
                    ariaLabel: ariaLabel,
                    accessKey: accessKey
                  }));
  };
  var marginLeftContent = "calc(50% - " + (String(((distance + itemWidth | 0) / 2 | 0) + Math.imul(itemWidth + distance | 0, page) | 0) + "px)");
  return React.createElement("div", {
              className: "slide-show-container"
            }, React.createElement("div", {
                  className: "slide-show-content",
                  style: {
                    marginLeft: marginLeftContent
                  }
                }, Belt_Array.mapWithIndex(children, (function (i, element) {
                        return React.createElement("div", {
                                    key: String(i),
                                    ref: Utils$NimbusWeb.setRef(i === page ? elementRef : dummyRef),
                                    className: "slide-show-element-container",
                                    id: "slide-show-item" + String(i),
                                    style: {
                                      margin: "0 " + (String(distanceHalf) + ("px 0 " + (String(distanceHalf) + "px"))),
                                      width: String(itemWidth) + "px"
                                    }
                                  }, element, i !== page ? React.createElement("div", {
                                          className: "slide-show-overlay"
                                        }) : null);
                      }))), page > 0 ? renderArrow(React.createElement(Icon_LeftArrow$NimbusWeb.make, {
                        color: /* Primary */0
                      }), toPreviousPage, -(arrowLeftPos - 32 | 0) | 0, "p", "Previous") : null, page < (children.length - 1 | 0) ? renderArrow(React.createElement(Icon_RightArrow$NimbusWeb.make, {
                        color: /* Primary */0
                      }), toNextPage, arrowLeftPos - 32 | 0, "n", "Next") : null);
}

var make = SlideShow;

exports.getWidth = getWidth;
exports.make = make;
/*  Not a pure module */
